/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimEditPageComponent} from './claim-edit-page.component';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ClaimInformationFormModule} from '../shared/claim-information-form/claim-information-form.module';
import {MaterialPositionTableModule} from '../shared/material-position-table/material-position-table.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {ClaimProgressModule} from '../shared/claim-progress/claim-progress.module';

@NgModule({
    declarations: [
        ClaimEditPageComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        NgbDropdownModule,
        ClaimInformationFormModule,
        MaterialPositionTableModule,
        LoadingSpinnerModule,
        ClaimProgressModule
    ],
    exports: [
        ClaimEditPageComponent
    ]
})

export class ClaimEditPageModule {
}
